import { AppEnvironmentT } from '@/types/common';

export const detectAppEnvironment = (): AppEnvironmentT => {
    const tg = window.Telegram?.WebApp;

    if (!tg || !tg.initData) {
        return 'web';
    }

    return 'telegram';
};
